export class EstadosMX {
  readonly estados: EstadoMX[] = [
    { "clave": "AGS", "nombre": "Aguascalientes" },
    { "clave": "BC",  "nombre": "Baja California" },
    { "clave": "BCS", "nombre": "Baja California Sur" },
    { "clave": "CMP", "nombre": "Campeche" },
    { "clave": "COA", "nombre": "Coahuila" },
    { "clave": "COL", "nombre": "Colima" },
    { "clave": "CHS", "nombre": "Chiapas" },
    { "clave": "CHI", "nombre": "Chihuahua" },
    { "clave": "CMX", "nombre": "Ciudad de México" },
    { "clave": "DGO", "nombre": "Durango" },
    { "clave": "MEX", "nombre": "Estado de México" },
    { "clave": "GTO", "nombre": "Guanajuato" },
    { "clave": "GRO", "nombre": "Guerrero" },
    { "clave": "HGO", "nombre": "Hidalgo" },
    { "clave": "JAL", "nombre": "Jalisco" },
    { "clave": "MCH", "nombre": "Michoacán" },
    { "clave": "MOR", "nombre": "Morelos" },
    { "clave": "NAY", "nombre": "Nayarit" },
    { "clave": "NL",  "nombre": "Nuevo León" },
    { "clave": "OAX", "nombre": "Oaxaca" },
    { "clave": "PUE", "nombre": "Puebla" },
    { "clave": "QRO", "nombre": "Querétaro" },
    { "clave": "QR",  "nombre": "Quintana Roo" },
    { "clave": "SLP", "nombre": "San Luis Potosí" },
    { "clave": "SIN", "nombre": "Sinaloa" },
    { "clave": "SON", "nombre": "Sonora" },
    { "clave": "TAB", "nombre": "Tabasco" },
    { "clave": "TMS", "nombre": "Tamaulipas" },
    { "clave": "TLX", "nombre": "Tlaxcala" },
    { "clave": "VER", "nombre": "Veracruz" },
    { "clave": "YUC", "nombre": "Yucatán" },
    { "clave": "ZAC", "nombre": "Zacatecas" }
  ];
}
export interface EstadoMX {
  clave: string;
  nombre: string;
}
